import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  personImage: {
    width: 85,
    height: 85,
    objectFit: 'cover',
    border: `1px solid ${theme.palette.primary.dark}`,
    borderRadius: 10
  },
  agreementHeading: {
    fontSize: 20,
    fontWeight: 500,
    textAlign: 'center',
    position: 'relative',
    textShadow: `0px 3px 6px ${theme.palette.grey[100]}`,
    color: theme.palette.primary.dark,
    '&::after': {
      content: "''",
      display: 'block',
      width: '25%',
      height: '2px',
      background: theme.palette.grey[900],
      right: '0%',
      top: '50%',
      position: 'absolute',
    },
    '&::before': {
      content: "''",
      display: 'block',
      width: '25%',
      height: '2px',
      background: theme.palette.grey[900],
      left: '0%',
      top: '50%',
      position: 'absolute',
    },
    [theme.breakpoints.down('md')]: {
      '&::before': {
        width: '75px',
      },
      '&::after': {
        width: '75px',
      }
    },
    '@media (max-width: 410px)': {
      '&::before': {
        width: '50px',
      },
      '&::after': {
        width: '50px',
      }
    }

  },
  btnWrapper: {
    '& button': {
      width: '100%'
    },
    '& .MuiCircularProgress-root': {
      color: '#fff'
    }
  },
  checkboxErrorText: {
    color: theme.palette.error.main,
    fontSize: 12
  },
}));
